import React, { useContext, useMemo } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { UserRoles, IItemForGetShortInfo } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import style from './RestaurantSelect.module.scss';

interface IProps {
	setSelectedRestaurant: (value: Nullable<string>) => void;
	selectedRestaurant: Nullable<string>;
	restaurantsOfSubcategory: IItemForGetShortInfo[];
}

export const RestaurantSelect: React.FC<IProps> = ({
	setSelectedRestaurant,
	selectedRestaurant,
	restaurantsOfSubcategory,
}) => {
	const { loggedUser } = useContext<IAppContext>(AppContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	const restaurants = useMemo(() => {
		if (hasAccess) {
			return restaurantsOfSubcategory;
		}
		const accessibleRestaurantIds = loggedUser.restaurants ? loggedUser.restaurants.map((el) => el.id) : [];
		return restaurantsOfSubcategory.filter((restaurant) => accessibleRestaurantIds.includes(restaurant.id));
	}, [hasAccess, loggedUser, restaurantsOfSubcategory]);

	const handleSelect = (value: Nullable<string>) => {
		setSelectedRestaurant(value);
	};

	return (
		<OutsideFormSelect
			containerClassName={style.container}
			className={style.select}
			testId="RestaurantSelect"
			name="RestaurantSelect"
			label="restaurantLabel"
			onChange={handleSelect}
			value={selectedRestaurant}
			options={restaurants}
			listItemHeight={restaurants?.length}
			withValidation={false}
		/>
	);
};
